import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { ContactCopy } from '@core/models/contacts-copy.model';

export interface ContactState extends EntityState<ContactCopy> {}

export function createInitialState(): ContactState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'contact', idKey: 'uid' })
export class ContactStore extends EntityStore<ContactState> {
  constructor() {
    super(createInitialState());
  }
}
